import apiClient from '@/plugins/apiClient'
let basePath = "/cms/pages";
import qs from 'qs';
import components from './components.js';

const author = JSON.parse(localStorage.getItem('account'));


export default {
     namespaced: true,
     state:{
          list: [],
          single: null,
          errors: {},
          message: null,
          meta: {
               current_page: 1,
               total: 0,
               per_page: 12
          },
          filters: {
               wheres : []
          },
          components: components,
          classes: [],
     },
     getters:{
          list: state => state.list,
          single: state => state.single,
          message: state => state.message,
          errors: state => state.errors,
          meta: state => state.meta,
          filters: state => state.filters,
          components: state => state.components,
          classes: state => state.classes,
     },
     mutations:{
        error(state, err) {
            console.log('mutation error',err);
            state.message = err.response.data.message
            state.errors = err.response.data.errors
        },
        setList(state, resp) {
            console.log('mutation setList',resp);
            state.list = resp.data
            state.message = null
            state.errors = {}
        },
        setMeta(state, resp){
          console.log('mutation setMeta',resp.meta);
          state.meta = resp.meta
          state.message = null
          state.errors = {}
        },
        setFilters(state, resp){
          console.log('mutation setFilters',resp.filters);
          state.filters = resp.filters
          state.message = null
          state.errors = {}
        },
        setSingle(state, resp){
               console.log('mutation setSingle',resp.data);
               state.single = resp.data
               state.message = null
               state.errors = {}
        },
        setComponents(state, resp){
          console.log('mutation setComponents',resp.data);
          state.components = resp.data
        },
        setClasses(state, resp){
          console.log('mutation setClasses',resp.data);
          state.classes = resp.data
          state.message = null
          state.errors = {}
        }
     },
     actions:{
          getList({commit, state}, data){
               return new Promise((resolve, reject) => {
                    console.log('GET LIST :'+data)
                    console.log('GET LIST filters:', state.filters)
                    
                    let params =  qs.stringify(state.filters, { arrayFormat: 'indices' })
                    apiClient.get(basePath+'?page='+state.meta.current_page+'&'+params).then(resp => {
                         commit('setList', resp.data);
                         commit('setMeta', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         console.log('GET SINGLE', err)
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          createSingle({commit}, data){

               if(author){
                    if(author.email){
                         data.author = author.email
                    }
               }

               return new Promise((resolve, reject) => {
                    console.log('Create Single:',data)
                    apiClient.post(basePath+'/create', data).then(resp => {
                         commit('setSingle', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         console.log('Create SINGLE', err)
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          duplicateSingle({commit}, data){
               if(author){
                    if(author.email){
                         data.author = author.email
                    }
               }
               return new Promise((resolve, reject) => {
                    console.log('Create Single:',data)
                    apiClient.post(basePath+'/'+data.id+'/duplicate').then(resp => {
                         // commit('setSingle', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         console.log('Create SINGLE', err)
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          getSingle({commit}, data){
               return new Promise((resolve, reject) => {
                    console.log('GET Single:'+data.id)
                    apiClient.get(basePath+'/'+data.id).then(resp => {
                         commit('setSingle', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         console.log('GET SINGLE', err)
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          getComponents({commit}){

               commit('setComponents', components);
               // return new Promise((resolve, reject) => {
               //      console.log('GET Components:')
               //      apiClient.get(basePath+'/components').then(resp => {
               //           commit('setComponents', resp.data);
               //           resolve(resp);
               //       })
               //       .catch(err => {
               //           console.log('GET Components', err)
               //           commit('error', err);
               //           reject(err);
               //       });
               // })
          },
          getClasses({commit}){
               return new Promise((resolve, reject) => {
                    console.log('GET Classes:')
                    apiClient.get(basePath+'/classes').then(resp => {
                         commit('setClasses', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         console.log('GET Classes', err)
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          updateSingle({commit}, data){
               if(author){
                    if(author.email){
                         data.author = author.email
                    }
               }
               return new Promise((resolve, reject) => {
                    console.log('Update Single :'+data.id)
                    apiClient.patch(basePath+'/'+data.id+'/update',data).then(resp => {
                         commit('setSingle', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         console.log('Update SINGLE', err)
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          deleteSingle({commit}, data){
               return new Promise((resolve, reject) => {
                    console.log('Update Single :'+data.id)
                    apiClient.delete(basePath+'/'+data.id+'/delete').then(resp => {
                         resolve(resp);
                     })
                     .catch(err => {
                         console.log('Update SINGLE', err)
                         commit('error', err);
                         reject(err);
                     });
               });
          },
          removeLanguage({commit}, data){
               return new Promise((resolve, reject) => {
                    console.log('Update Single :'+data.id)
                    apiClient.patch(basePath+'/'+data.id+'/remove-language', data).then(resp => {
                         commit('setSingle', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         console.log('Update SINGLE', err)
                         commit('error', err);
                         reject(err);
                     });
               });
          },
          autoTranslator({commit}, data){
               return new Promise((resolve, reject) => {
                    console.log('autoTranslator', data)
                    apiClient.post(basePath+'/auto-translator', data).then(resp => {
                         resolve(resp);
                         return resp;
                     })
                     .catch(err => {
                         console.log('Update SINGLE', err)
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          setAsSingle({state}, data){
               state.single = data;
          },
          setMeta({commit}, data){
               console.log('action meta',data);
               commit('setMeta',{meta:data});
               // commit('success', true);
          },
          setFilters({commit}, data){
               console.log('action setFilters',data);
               commit('setFilters',{filters:data});
          }
     },
}